module.exports = __webpack_public_path__ + "static/media/stand_3.3cc361b5.png";